import { render } from "./StatisticsTableCategories.vue?vue&type=template&id=645e16ab&scoped=true&ts=true"
import script from "./StatisticsTableCategories.vue?vue&type=script&lang=ts"
export * from "./StatisticsTableCategories.vue?vue&type=script&lang=ts"

import "./StatisticsTableCategories.vue?vue&type=style&index=0&id=645e16ab&scoped=true&lang=scss"

import exportComponent from "/Users/goodwin/Desktop/Fehrya/Dev_goodwin/tools/easynwk-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645e16ab"]])

export default __exports__